import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function verifyPaymentCallback(order_id, token) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.VERIFY_PAYMENT_CALLBACK_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.orders.verifyPaymentCallback({ order_id, token });
		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.VERIFY_PAYMENT_CALLBACK_ERROR,
				payload: {
					loading: false,
					meta: response.meta
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.VERIFY_PAYMENT_CALLBACK_SUCCESS,
			payload: {
				loading: false,
				order: response.data || null,
				meta: response.meta
			}
		});
	};
}

export function resetPage() {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.RESET_PAYMENT_CALLBACK_PAGE
		});
	};
}
